import React, { useState } from "react";
import { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import _ from "lodash";
import ApiAmusementService from "../../../../core/api/api.amusementService";

const ChangesHistoryModal = ({ showModalChangesHistory, setShowModalChangesHistory, selectedServiceId }) => {
  const [changesHistory, setChangesHistory] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      if (selectedServiceId == 0) return;
      try {
        const response = await ApiAmusementService.getReserveDetailChangesHistory({ id: selectedServiceId });
        setChangesHistory(response);
        setLoadingData(false);
      } catch (error) {
        setLoadingData(false);
      }
    };
    fetchData();
  }, [selectedServiceId]);

  const handleCloseShowModal = () => {
    setShowModalChangesHistory(false);
  };

  return (
    <Modal show={showModalChangesHistory} onHide={handleCloseShowModal}>
      <Modal.Header closeButton>
        <Modal.Title> تاریخچه تغییرات فرم رزرو</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {selectedServiceId == 0 && <div>ابتدا تفریح مورد نظر را انتخاب کنید.</div>}
        {selectedServiceId != 0 && (loadingData ? (
          <div> در حال دریافت اطلاعات </div>
        ) : (
          <>
            {changesHistory.length === 0 && <div>تاریخچه ای برای این تفریح ثبت نشده است.</div>}
            {changesHistory.length > 0 && (
              <ul className="px-4">
                {changesHistory.map((item) => (
                  <li className="py-2">
                    <div className=" d-flex align-items-center">
                      <div className="px-1">{item.date}</div>
                      <div className="px-2"> - </div>
                      <div xs className="px-1">
                        {item.userFullName}
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </>
        ))}


      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseShowModal}>
          بستن
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangesHistoryModal;
